import { useState, useEffect, useRef, useCallback, Fragment, useMemo } from "react";
import { v4 } from "uuid";
import * as YStyled from "../../../Styleds";
import FriendsIcon from "./FriendsIcon";
const LogItem = ({ title, date, point,peoples,cb,type="view" }) => {
    return (
        <YStyled.Col gap=".8rem" style={{borderRadius:"1rem",background:"white",padding:"1rem",width:"100%"}}>
            <YStyled.Span size={17}>{title}</YStyled.Span>
            <YStyled.Row>
                <YStyled.Span size={13} fontWeight={400} fontFamily="SF Pro">{`${date}・${point}`}</YStyled.Span>
            </YStyled.Row>
            <YStyled.Row>
                <FriendsIcon users={peoples} />
                {type==="view" &&
                <YStyled.BTN5>
                    <YStyled.Span  size={15} fontWeight={400} fontFamily="SF Pro" onClick={e=>{
                        cb()
                    }}>查看</YStyled.Span>
                </YStyled.BTN5>
                }
                {type==="addPhoto" &&
                <YStyled.BTN5>
                    <YStyled.Span  size={15} fontWeight={400} fontFamily="SF Pro" onClick={e=>{
                        cb()
                    }}>新增</YStyled.Span>
                </YStyled.BTN5>
                }
            </YStyled.Row>
        </YStyled.Col>
    );
}

export default LogItem;